<template>
  <div class="boss-message-heading">
    <div
      class="boss-message-heading-when"
      data-test="date"
    >
      {{ date | formatDate }}
    </div>
    <div
      class="boss-message-heading-title"
      data-test="entry-info"
    >
      {{ fullName }}さんが『求人ID：{{ job.id }} {{ job.name }}』に応募しました。
    </div>
    <template v-if="showSpecialFavor">
      <div
        class="boss-message-heading-text"
        data-test="scout-special-favor"
      >
        スカウト特典があります！
      </div>
      <div class="boss-bonus-check-group">
        <template v-for="(specialFavor, i) in specialFavors">
          <span
            v-if="specialFavor.isEffective"
            :key="i"
            v-tooltip="{ content: specialFavorBy(specialFavor.id).description}"
            :data-test="'special-favor-' + i "
            class="boss-bonus-check-text boss-check-true"
          >{{ specialFavor.name }}</span>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : defaultLabel
    }
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    job: {
      type: Object,
      default: () => ({
        id: null,
        name: ''
      })
    },
    specialFavors: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    fullName () {
      return `${this.lastName} ${this.firstName}`
    },
    showSpecialFavor () {
      return _.some(this.specialFavors, 'isEffective')
    }
  }
}
</script>
